import React from "react";
import { useTranslation } from "react-i18next";
import { Typography } from "@mui/material";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import { useStyles } from "./GoToHomeScreenButton.styles";
import { IGoToHomeScreenButtonProps } from "./GoToHomeScreenButtonInterfaces";

export const GoToHomeScreenButton = ({ handleClick }: IGoToHomeScreenButtonProps) => {
    const { t } = useTranslation();
    const classes = useStyles();

    return (
        <button type="button" onClick={handleClick} className={classes.button}>
            <Typography variant="h5">
                <span className={classes.message}>
                    <HomeOutlinedIcon className={classes.icon} />{" "}
                    {t("HMI.failure_details.go_to_home_screen").toUpperCase()}
                </span>
            </Typography>
        </button>
    );
};
